import "./EntryGroupTemplateEditor.less";

import { Spin } from "antd";
import arrayMove from "array-move";
import * as React from "react";
import { RouteComponentProps } from "react-router";

import { EntryGroupTemplateApi } from "lib/api";
import { CancellationToken } from "lib/api/base";
import { RequirementItem, SingleItemRequirement } from "lib/data/model";
import { DataFieldTemplate, EntryGroupTemplate, MultipleItemRequirement } from "lib/data/model";
import { Requiredness } from "lib/data/model/enumerations";
import { StateService } from "lib/services";

import { TemplateTitle } from "../../components";
import { Breadcrumb } from "../../TemplateHierarchy/components/Breadcrumb";
import { DataFieldTemplateSelector } from "../DataFieldTemplateSelector";

interface IMatchProps {
	sectionId?: string;
	id: string;
}

interface IEntryGroupTemplateEditorProps extends RouteComponentProps<IMatchProps> {

}

interface IEntryGroupTemplateEditorState {
	awaitingUpdate: boolean;
}


export class EntryGroupTemplateEditor extends React.Component<IEntryGroupTemplateEditorProps, IEntryGroupTemplateEditorState> {

	private apiCancellationToken: CancellationToken = new CancellationToken();


	private entryGroupTemplate?: EntryGroupTemplate;
	private dataFieldTemplates: DataFieldTemplate[] = [];

	public constructor(props: IEntryGroupTemplateEditorProps) {

		super(props);

		this.state = {
			awaitingUpdate: false
		};
	}

	public componentWillMount = async () => {
		this.setupEntryGroup();
	}

	public componentWillUnmount() {

		// Cancel Outstanding API Calls
		this.apiCancellationToken.cancel();
	}

	public setupEntryGroup = async (callback?: Function) => {
		const { id } = this.props.match.params;
		this.entryGroupTemplate = await EntryGroupTemplateApi.getEntryGroupTemplateById(Number(id));
		// Build Columns
		this.buildTableColumns();
		this.forceUpdate();
		if (callback) {
			callback();
		}
	}

	public softUpdate = async () => {
		if (this.entryGroupTemplate) {
			this.forceUpdate();
			await EntryGroupTemplateApi.updateEntryGroupTemplateById(this.entryGroupTemplate);
		}
	}
	public hardUpdate = async (callback?: Function) => {
		if (this.entryGroupTemplate) {
			// set to loading
			StateService.setCancelableState(() => this.setState({ awaitingUpdate: true }), this.apiCancellationToken);
			await EntryGroupTemplateApi.updateEntryGroupTemplateById(this.entryGroupTemplate);
			this.setupEntryGroup(() => {
				StateService.setCancelableState(() => this.setState({ awaitingUpdate: false }), this.apiCancellationToken);
				if (callback) {
					callback();
				}
			});
		}
	}
	public buildTableColumns = () => {
		if (this.entryGroupTemplate) {
			this.dataFieldTemplates = [];
			this.entryGroupTemplate.requirements.map((requirement, index) => {
				switch (requirement.$type) {
					case SingleItemRequirement.$type.DataFieldTemplate:
						const singleItemRequirement: SingleItemRequirement<DataFieldTemplate> = requirement as SingleItemRequirement<DataFieldTemplate>;
						const dataFieldTemplate: DataFieldTemplate = singleItemRequirement.item.item;
						dataFieldTemplate.getParent = (): SingleItemRequirement<DataFieldTemplate> => singleItemRequirement as SingleItemRequirement<DataFieldTemplate>;
						this.dataFieldTemplates.push(dataFieldTemplate);
						break;
					case MultipleItemRequirement.$type.DataFieldTemplate:

						break;

					default:
						break;
				}
			})
			this.dataFieldTemplates.sort((a: DataFieldTemplate, b: DataFieldTemplate) => {
				if (a.getParent && b.getParent) {
					const aSingleItemTemplate = a.getParent().item.initialOrder;
					const bSingleItemTemplate = b.getParent().item.initialOrder;
					return aSingleItemTemplate - bSingleItemTemplate;
				}
				return 0;
			})

		}
	}




	public changeName = (newName: string) => {
		if (this.entryGroupTemplate) {
			this.entryGroupTemplate.name = newName;
			this.softUpdate();
		}

	}

	public addDataFieldTemplate = (dataFieldTemplate: DataFieldTemplate, callback: Function) => {
		if (this.entryGroupTemplate) {
			// crete a single Item Requirement
			const singleItemRequirement = new SingleItemRequirement<DataFieldTemplate>("DataFieldTemplate");
			singleItemRequirement.isRepeatable = false;
			singleItemRequirement.requiredness = Requiredness.REQUIRED;

			// Create a requirement Item
			const requirementItem = new RequirementItem<DataFieldTemplate>("DataFieldTemplate");
			requirementItem.initialOrder = this.entryGroupTemplate.requirements.length + 1;
			// Add data template field to requirement item
			requirementItem.item = dataFieldTemplate;
			// add requirement item to single Item requirement
			singleItemRequirement.item = requirementItem;
			// add requirement to entry group
			this.entryGroupTemplate.requirements.push(singleItemRequirement);
			this.hardUpdate(callback)

		}
	}

	public removeDataFieldTemplate = (dataFieldTemplate: DataFieldTemplate) => {
		if (this.entryGroupTemplate) {
			const entryGroupRequirements = [...this.entryGroupTemplate.requirements];
			this.entryGroupTemplate.requirements = entryGroupRequirements.filter(requirement => {
				const singleItemRequirement: SingleItemRequirement<DataFieldTemplate> = requirement as SingleItemRequirement<DataFieldTemplate>;
				if (singleItemRequirement) {
					if (singleItemRequirement.item.item.id != dataFieldTemplate.id) {
						return singleItemRequirement;
					}

				}
			});
			this.buildTableColumns();
			this.softUpdate();
		}
	}
	public moveDataFieldTemplate = (oldIndex: number, newIndex: number) => {
		if (this.entryGroupTemplate) {
			this.dataFieldTemplates = arrayMove(this.dataFieldTemplates, oldIndex, newIndex);
			this.dataFieldTemplates.forEach((dataFieldTemplate, index) => {
				if (dataFieldTemplate.getParent) {
					dataFieldTemplate.getParent().item.initialOrder = index;
				}
			});
			this.softUpdate();
		}
	}

	public render() {

		if (this.entryGroupTemplate) {

			return (
				<div className="entry-group-template-editor">

					{this.props.match.params.sectionId ? <Breadcrumb /> : null}

					{this.entryGroupTemplate.isReusable ?
						<TemplateTitle templateName={this.entryGroupTemplate.name} reusableFlag={true} onNameChange={this.changeName} />
						:
						<TemplateTitle templateName={this.entryGroupTemplate.name + " Template"} onNameChange={this.changeName} />
					}

					<DataFieldTemplateSelector
						softUpdate={this.softUpdate}
						removeDataFieldTemplate={this.removeDataFieldTemplate}
						moveDataFieldTemplate={this.moveDataFieldTemplate}
						awaitingUpdate={this.state.awaitingUpdate}
						addDataFieldTemplate={this.addDataFieldTemplate}
						dataFieldTemplates={this.dataFieldTemplates}
					/>
				</div>

			);
		}
		else {

			return <Spin />;
		}
	}
}
